var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { v4 } from "uuid";
import { JSONRPC, JSONRpcError } from "./rpc.interface";
import { isAndroidPlatform, sentAndroidRequest } from "../android";
import { isIOSPlatform, sendIOSRequest } from "../ios";
function toJSONRPC(method, params) {
    var id = v4();
    return { id: id, jsonrpc: "2.0", method: method, params: params };
}
var TIMEOUT = 30 * 1000;
export function createJob() {
    var resolve;
    var reject;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    var newJob = {
        promise: promise,
        resolve: resolve,
        reject: reject,
    };
    return newJob;
}
function getPlatform() {
    var platformLog = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log.apply(console, __spreadArray(["PLATFORM:"], args, false));
    };
    if (isAndroidPlatform()) {
        platformLog("Android");
        return "android";
    }
    if (isIOSPlatform()) {
        platformLog("iOS");
        return "ios";
    }
}
var RpcClient = /** @class */ (function () {
    function RpcClient(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.options = options;
        this._platform = getPlatform();
        this._callbackMap = new Map();
        this._subscribers = new Map();
        this._onResponse = function (event) {
            var detail = event.detail;
            var id = detail.id, error = detail.error, result = detail.result;
            var cb = _this._callbackMap.get(id);
            _this._callbackMap.delete(id);
            if (typeof cb === "function") {
                cb(error, result);
            }
        };
        this._onEvent = function (event) {
            var detail = event.detail;
            var method = detail.method, params = detail.params;
            var cb = _this._subscribers.get(method);
            if (typeof cb === "function") {
                cb(params);
            }
        };
        this._prepare = function () {
            window.addEventListener(JSONRPC.EVENT_LIST.RESPONSE, _this._onResponse);
            window.addEventListener(JSONRPC.EVENT_LIST.EVENT, _this._onEvent);
        };
        console.log('RPC client constructor');
        this._prepare();
    }
    RpcClient.prototype.response = function (data) {
        var customEvent = new CustomEvent(JSONRPC.EVENT_LIST.RESPONSE, { detail: data });
        window.dispatchEvent(customEvent);
    };
    RpcClient.prototype.mount = function () {
        var customEvent = new CustomEvent(JSONRPC.EVENT_LIST.MOUNT);
        window.dispatchEvent(customEvent);
    };
    RpcClient.prototype.event = function (data) {
        var customEvent = new CustomEvent(JSONRPC.EVENT_LIST.EVENT, { detail: data });
        window.dispatchEvent(customEvent);
    };
    RpcClient.prototype.subscribe = function (event, listener) {
        this._subscribers.set(event, listener);
    };
    RpcClient.prototype.unsubscribe = function (event) {
        this._subscribers.delete(event);
    };
    RpcClient.prototype.request = function (method, params) {
        var _this = this;
        var req = toJSONRPC(method, params);
        var newJob = createJob();
        setTimeout(function () {
            var cb = _this._callbackMap.get(req.id);
            _this._callbackMap.delete(req.id);
            if (typeof cb === "function") {
                var error = new JSONRpcError(500, "Timeout Error");
                console.log(error);
                cb({
                    error: error,
                    id: null,
                });
            }
        }, this.options.timeout || TIMEOUT);
        this._callbackMap.set(req.id, function (err, result) {
            if (err) {
                newJob.reject(err);
            }
            else {
                newJob.resolve(result);
            }
        });
        switch (this._platform) {
            case "android": {
                sentAndroidRequest(req);
                break;
            }
            case "ios": {
                sendIOSRequest(req);
                break;
            }
            default:
                throw new Error("Unsupported platform!");
        }
        return newJob.promise;
    };
    return RpcClient;
}());
export { RpcClient };
;
